// Soon-to-be-obsolete legacy code
// TODO MK: Remove file post-shapefile migration
import store from '@/store/index.js'
import { sasNeedsRefresh, createResourceUrl, blobSegmentsFromUrl } from '@/utils/SasHelpers'
import ApiServer from '@/utils/api/ApiServer'
import { BlobServiceClient } from '@azure/storage-blob'
import i18n from '@/i18n'
import { SasTokenLocations } from '@/utils/LocalStorageActor'
import shp from 'shpjs'
import { getBlobByFileName, getBlobByFileExtension } from '@/utils/storage/BlobStorageHelpers'

const SHAPEFILE_EXTENSION = 'zip'
const LEGACY_GEOJSON_FILE_NAME = 'geojson.json'
export const SHAPEFILE_TYPES = ['application/zip', 'application/x-zip-compressed']
export const PREFERRED_SHAPEFILE_TYPE = 'application/zip'

class ShapefileClient {
  async getContainerClient () {
    await this.initConnection()
    return this.containerClient
  }

  async getEndpoint () {
    return 'companyinfo/blobinfo/tractshapes'
  }

  async initConnection () {
    const sasCapsule = JSON.parse(localStorage.getItem(SasTokenLocations.SHAPE_FILES_SAS))
    if (sasCapsule === null || sasNeedsRefresh(sasCapsule.data[0].blobSasUri)) {
      const endpoint = await this.getEndpoint()
      const response = await ApiServer.get(ApiServer.urlFor(endpoint))
      localStorage.setItem(SasTokenLocations.SHAPE_FILES_SAS, JSON.stringify(response))
    }

    const storedResponse = JSON.parse(localStorage.getItem(SasTokenLocations.SHAPE_FILES_SAS))
    this.container = storedResponse.data[0].container
    this.location = storedResponse.data[0].location
    this.client = new BlobServiceClient(storedResponse.data[0].blobSasUri)
    this.containerClient = this.client.getContainerClient(this.container)
  }

  getBlobLocation (tractId) {
    return `${this.location}/${tractId}/`
  }

  async getShapefileUrl (tractId) {
    try {
      const containerClient = await this.getContainerClient()
      const blobLocation = this.getBlobLocation(tractId)
      const blobs = containerClient.listBlobsByHierarchy('/', { prefix: blobLocation })
      const blobItem = await getBlobByFileExtension(blobs, SHAPEFILE_EXTENSION)
      if (!blobItem) return
      const blobUrl = createResourceUrl(JSON.parse(localStorage.getItem(SasTokenLocations.SHAPE_FILES_SAS)).data[0].blobSasUri, this.container, blobItem.value.name)
      return blobUrl.href
    } catch (e) {
      if (e.name === 'TypeError') {
        console.warn('No shapefile for tract #' + tractId)
      }
      if (e.code !== 'AuthorizationFailure') {
        console.warn(i18n.t('getShapefileFailure', { tractName: store.getters['tract/allTracts'].find(t => t.tractId === tractId)?.name ?? '' }))
      }
      throw e
    }
  }

  async getShapefileBlob (tractId) {
    try {
      const containerClient = await this.getContainerClient()
      const blobLocation = this.getBlobLocation(tractId)
      const blobs = containerClient.listBlobsByHierarchy('/', { prefix: blobLocation })
      const blobItem = await getBlobByFileExtension(blobs, SHAPEFILE_EXTENSION)
      return blobItem
    } catch (e) {
      if (e.name === 'TypeError') {
        console.warn('No shapefile for tract #' + tractId)
      }
      if (e.code !== 'AuthorizationFailure') {
        console.warn(i18n.t('getShapefileFailure', { tractName: store.getters['tract/allTracts'].find(t => t.tractId === tractId).name ?? '' }))
      }
      throw e
    }
  }

  async deleteFile (tractId, fileUrl) {
    try {
      await this.initConnection()
      const [, ...fileName] = blobSegmentsFromUrl(fileUrl, this.location)
      await ApiServer.delete(ApiServer.urlFor(`tracts/${tractId}/shape/${fileName.map(encodeURIComponent).join('/')}`))
      await ApiServer.delete(ApiServer.urlFor(`tracts/${tractId}/shape/${LEGACY_GEOJSON_FILE_NAME}`))
    } catch (e) {
      store.dispatch('snackbar/setSnackError', i18n.t('deleteShapefileFailure', { tractName: store.getters['tract/allTracts'].find(t => t.tractId === tractId).name ?? '' }))
      throw e
    }
  }

  async deleteShapefile (tractId) {
    try {
      let existingShapefile = null
      existingShapefile = await this.getShapefileUrl(tractId)
      if (existingShapefile) await this.deleteFile(tractId, existingShapefile)
    } catch (e) { /* No existing shapefile  */ }
  }

  async uploadShapefile (tractId, shapefile) {
    // Delete exisiting shapefile if it exists
    try {
      let exisitingShapefile = null
      exisitingShapefile = await this.getShapefileUrl(tractId)
      if (exisitingShapefile) await this.deleteFile(tractId, exisitingShapefile)
    } catch (e) { /* No exisiting shapefile  */ }
    try {
      const containerClient = await this.getContainerClient()
      const fullBlobLocation = await this.getBlobLocation(tractId) + shapefile.name
      const blockBlobClient = await containerClient.getBlockBlobClient(fullBlobLocation)
      const options = {
        blobHTTPHeaders: {
          blobContentType: shapefile.type
        }
      }
      await blockBlobClient.uploadData(shapefile, options)
    } catch (e) {
      console.error(e)
      if (e.code !== 'AuthorizationFailure') store.dispatch('snackbar/setSnackError', i18n.t('uploadShapefileFailure', { tractName: store.getters['tract/allTracts'].find(t => t.tractId === tractId).name ?? '' }))
      throw e
    }
  }

  async getLegacyGeojson (tractId) {
    const containerClient = await this.getContainerClient()
    const blobLocation = await this.getBlobLocation(tractId)
    const blobs = containerClient.listBlobsByHierarchy('/', { prefix: blobLocation })
    const blobItem = await getBlobByFileName(blobs, LEGACY_GEOJSON_FILE_NAME)

    const blobUrl = createResourceUrl(JSON.parse(localStorage.getItem(SasTokenLocations.SHAPE_FILES_SAS)).data[0].blobSasUri, this.container, blobItem.value.name)
    return blobUrl.href
  }

  async uploadGeojson (tractId, geojsonFile) {
    // check for existing geojson
    try {
      let existingJson = null
      existingJson = await this.getLegacyGeojson(tractId)
      if (existingJson) await this.deleteFile(tractId, existingJson)
    } catch (e) {
      // no existing geojson
    }
    try {
      const containerClient = await this.getContainerClient()
      const fullBlobLocation = this.getBlobLocation(tractId) + geojsonFile.name
      const blockBlobClient = containerClient.getBlockBlobClient(fullBlobLocation)
      const options = {
        blobHTTPHeaders: {
          blobContentType: geojsonFile.type
        }
      }
      await blockBlobClient.uploadData(geojsonFile, options)
    } catch (e) {
      console.error(e)
    }
  }
}

export const shapefileClient = new ShapefileClient()

export async function getShapeFileAsArrayBuffer (shapefile) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      resolve(reader.result)
    }
    reader.onerror = reject
    reader.readAsArrayBuffer(shapefile)
  })
}

export async function getGeojsonFromShapefile (shapefile) {
  try {
    const asArrayBuffer = await getShapeFileAsArrayBuffer(shapefile)
    return await shp(asArrayBuffer)
  } catch (e) {
    return null
  }
}
